import { RootState } from "@/modules/common";

export const selectImpersonation = ({ auth }: RootState) => {
  return auth.impersonateeEmail;
};
